const NIMBUS_DATA_TYPES = {
  STRING: 'String',
  BOOLEAN: 'Boolean',
  INTEGER: 'Integer',
};

module.exports = {
  NIMBUS_DATA_TYPES,
};
